import {useOidc, verifyToken} from '~/oidc'

export const useAuthenticated = () => {
	const {
		oidcTokens,
		login,
		logout,
		isUserLoggedIn,
		params,
		subscribeToAutoLogoutCountdown,
		goToAuthServer,
		initializationError,
	} = useOidc()

	const token = oidcTokens?.accessToken
	const user = verifyToken(token)
	return {
		goToAuthServer,
		initializationError,
		isUserLoggedIn,
		login,
		logout,
		oidcTokens,
		params,
		subscribeToAutoLogoutCountdown,
		user,
	}
}
